var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"cz2__funko-logos cz2__funko-logo-link",attrs:{"href":_vm.funkoUrl,"aria-label":_vm.$t('FUNKO_HOME')},on:{"click":_vm.tapLogo}},[(!_vm.isSplashPage)?_c('img',{class:_vm.isNameStep || _vm.isReviewStep || _vm.isCheckoutStep ? 'cz2__funko-logo-last-steps' : 'cz2__funko-logo',attrs:{"src":require("../assets/images/funko-logo@2x.png"),"alt":_vm.$t('LOGO_FUNKO')}}):_vm._e(),(_vm.showPyLogo)?_c('img',{class:[
            {
                'cz2__py-logo-splash': _vm.isSplashPage,
                'cz2__py-logo-last-steps': _vm.isNameStep || _vm.isReviewStep || _vm.isCheckoutStep,
            },
        ],attrs:{"src":require("../assets/images/pop-yourself-logo.svg"),"alt":"Pop! Yourself Logo"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }